import React, { Fragment, useEffect } from "react"
import ReactDOM from "react-dom"
import { Box, List, ListItem, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import EventItem from "./EventItem"
import { useDispatch, useSelector } from "react-redux"
import * as actionContents from "../../../store/actions/contentActions"
const useStyles = makeStyles(theme => ({
  ullist: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}))
const EventsList = () => {
  const dispatch = useDispatch()
  const { eventsItems } = useSelector(state => ({
    eventsItems: state.content.eventsData,
  }))
  useEffect(() => {
    dispatch(actionContents.fetchXMLHttpRequest("events"))
  }, [])

  const classes = useStyles()
  return (
    <Fragment>
      <Box component="div" className="mez sorter"></Box>
      <Box component="div" className="mez calendar-list">
        <Box component="div" className="calendar-list__block">
          <List className={classes.ullist}>
            {eventsItems &&
              eventsItems.map((event, index) => (
                <EventItem data={event} key={index} />
              ))}
          </List>
        </Box>
      </Box>
    </Fragment>
  )
}

export default EventsList
